<template>
  <tr class="account-row">
    <td>
      <router-link :to="{ path: '/membership/members/' + valet.Account.uuid }">
        {{ valet.Account.dropdownLabel }}
      </router-link>
    </td>
    <td>
      <div class="text-center">
        Valet #{{ valet.reservationId }}
      </div>
    </td>
    <td>
      <template v-for="car in valet.Cars">
        <span :key="car.uuid">
          <router-link :to="`/fleet/vehicles/${car.uuid}`">
            {{ car.dropdownLabel }}
          </router-link>
          <br>
        </span>
      </template>
    </td>
    <td>
      <button class="btn btn-sm btn-danger" @click="executeAction('deleteValet', valet.uuid)">
        <span class="fa fa-trash-alt fa-fw"></span> Delete
      </button>
      <router-link class="btn btn-sm btn-warning" :to="`/fleet/valets/edit/${valet.uuid}`">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button class="btn btn-sm btn-primary" type="button" @click="executeAction('techPushValet', valet.uuid)">
        <span class="fa fa-cloud-upload-alt fa-fw"></span> Tech Push
      </button>
    </td>
  </tr>
</template>

<script>
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import { TECH_PUSH_VALET, DELETE_VALET } from '@/vuex/types'
import { mapActions } from 'vuex'

export default {
  components: {
    AccountNoteDisplay
  },
  name: 'Valet',
  props: {
    object: {
      type: Object
    }
  },
  data () {
    return {
      updatedValet: {},
      stripeURL: 'https://dashboard.stripe.com/search?query=%23'
    }
  },
  computed: {
    valet () {
      return {
        Account: {
          AccountType: {}
        },
        Cars: [],
        AccountNotes: [],
        ...this.object,
        ...this.updatedValet
      }
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedValet = result.updated
      this.$router.go('/fleet/valets?t=' + new Date().getTime())
    },
    ...mapActions([
      DELETE_VALET,
      TECH_PUSH_VALET
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Valet.vue